<template>
  <div class="my-account-container">
    <template v-if="memberPortalActive">
      <b-dropdown
        text="My Account"
        title="My Account"
        class="nav-link portal"
        data-cy="my-portal-link"
        right
        no-caret
        variant="link"
      >
        <div
          slot="button-content"
          class="nav-link-button-inner"
        >
          <page-top-svg-icons
            name="PortalIcon"
          />
          <span class="nav-label">My Portal</span>
        </div>
        <b-dropdown-item
          :to="`/user/${userId}`"
          :title="`${fullname} [ID: ${userId}]`"
          data-cy="member-portal-link"
        >
          My Portal
        </b-dropdown-item>
        <user-logout
          class="dropdown-item"
          in-dropdown
        />
      </b-dropdown>
    </template>
    <template v-else>
      <user-logout class="logout" />
    </template>
  </div>
</template>
<script>
import PageTopSvgIcons from './page-top-svg-icons'

export default {
  components: {
    PageTopSvgIcons
  },
  data() {
    return {
    }
  },
  computed: {
    userId() {
      return this.$store.getters['user/userid']
    },
    fullname() {
      return this.$store.getters['user/fullname']
    },
    memberPortalActive() {
      return this.$store.state.registry.getFeature('member-portal')
    }
  }
}
</script>
